import main1Image from '../assets/images/collaborations/main1.png'
import main2Image from '../assets/images/collaborations/main2.png'
import main3Image from '../assets/images/collaborations/main3.png'

export const COLLABORATIONS_MAIN_SECTIONS = [
  {
    id: 'toyota',
    eyebrow: 'Infrastructure & Operations',
    title: 'Toyota',
    description:
      'Supporting Toyota service operations through equipment supply, facility setup, and implementation of global service standards.',
    features: [
      'Workshop equipment & installation',
      'Process optimization',
      'Dealer standards alignment',
    ],
    image: main1Image,
    reversed: false,
  },
  {
    id: 'nissan',
    eyebrow: 'Network & Performance',
    title: 'Nissan',
    description:
      'Enhancing dealer network efficiency and aligning operations with brand requirements.',
    features: [
      'Dealer performance improvement',
      'Operational consultancy',
      'Standards implementation',
    ],
    image: main2Image,
    reversed: true,
  },
  {
    id: 'geely',
    eyebrow: 'Market Entry',
    title: 'Geely',
    description:
      'Establishing a structured market presence through distribution setup and dealer network development.',
    features: [
      'Distribution strategy',
      'Dealer network setup',
      'Market positioning',
    ],
    image: main3Image,
    reversed: false,
  },
]
